import { useMutation } from "react-query"
import api from "../client"
import { AuthResetPasswordPayload } from "../types/auth"

const postData = async (payload: AuthResetPasswordPayload) => {
    const { data } = await api.post(
        "/users/reset-password",
        payload
    )
    return data
}

export const useAuthResetPassword = () => {
    return useMutation((payload: AuthResetPasswordPayload) => {
        return postData(payload)
    })
}
